<template>
    <teleport to="body">
        <div
            class="modal-mask"
            @click.stop="close"
        >
            <transition name="modal-fade" appear>
                <div
                    ref="content"
                    class="routa-modal-container"
                    :class="{
              'no-top-pad': noTopPadding,
              'col-sm-5': size !== 'sm' && size !== 'xl' && size !== 'lg',
              'col-sm-3': size === 'sm',
              'col-sm-8': size === 'lg',
              'col-sm-10': size === 'xl',
              'modal-no-padding': noPadding,
              'overflow-visible' : allowOverflow
          }"
                    @click.stop=""
                >
                    <div v-if="!hideHeader" class="col-12 d-flex justify-content-between align-items-center mb-3"
                         @click.stop="null">
                        <span class="modal-header mb-0" @click.stop="null">{{ title }}</span>
                        <div v-if="!preventClose && !hideHeaderClose" class="nopads" @click.stop="close">
                            <font-awesome-icon class="modal-close-icon mt-1" icon="close" role="button"/>
                        </div>
                    </div>
                    <slot/>
                    <div v-if="!hideFooter" class="col-12 d-flex justify-content-end" style="pointer-events: auto;">
                        <button class="btn btn-secondary btn-sm form-button" @click.stop="close">{{
                                $t('common.close')
                            }}
                        </button>
                        <button class="btn btn-success btn-sm form-button" @click.stop="$emit('ok')">{{
                                $t('common.ok')
                            }}
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </teleport>
</template>

<script>
export default {
    name: 'BaseModal',
    props: {
        noPadding: {
            type: Boolean,
            default: false
        },
        noTopPadding: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: Boolean,
            default: false
        },
        preventClose: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: 'md'
        },
        allowOverflow: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close', 'ok'],
    methods: {
        close() {
            if (!this.preventClose) {
                this.$emit('close')
            }
        }
    }
}
</script>

<style scoped>

.routa-modal-container {
    margin: 40px auto;
    padding: .5em 1em;
    max-height: calc(100% - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    border-radius: .5em;
    border: #7FC000 1px solid;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .88);
    Transition: all .3s ease;
    pointer-events: auto;
}

.no-top-pad {
    padding-top: 0 !important;
}

.modal-header {
    display: inline-block;
    font-size: 1.6em;
    color: #0b4b8f;
}

.modal-close-icon {
    display: inline-block;
    font-size: 1em;
    padding: .5em;
}

.modal-no-padding {
    padding: 0 !important;
}

.overflow-visible {
    overflow: visible;
}


/* ---- Fade in/out for the parent (mask) ---- */
:deep(.modal-fade-enter-active),
:deep(.modal-fade-leave-active) {
    transition: opacity 250ms ease-in-out;
}

:deep(.modal-fade-enter-from),
:deep(.modal-fade-leave-to) {
    opacity: 0;
}

:deep(.modal-fade-enter-to),
:deep(.modal-fade-leave-from) {
    opacity: 1;
}

</style>
